export const style = {
  boxContainer: {
    sx: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: 1,
      whiteSpace: 'break-spaces',
    },
    boxRow: {
      sx: {
        color: 'text.secondary',
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'break-spaces',
      },
    },
    Typography: {
      variant: 'caption',
      text: 'text.secondary',
      whiteSpace: 'break-spaces',
      wordBreak: 'break-word',
    },
  },
} as const;
